import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import { Box, Stack} from "@mui/material";
import ToggleContent from "components/lib-ui/ToggleContent";
import { useTheme } from "@mui/material/styles";
import ExperienceFilters from "./ExperienceFilters";
import PreferredFilters from "./PreferredFilters";
import LocationSearchOnline from "./locationFilter/LocationSearchOnline";

export const PoolCreationFilters = ({ handleSubmit, formData }) => {
    const { getValues } = formData;
    const theme = useTheme();

    const handleInputSubmit = (event) => {
        const filterData = getValues();

        const { salaryMinimum, salaryMaximum } = filterData;

        if (salaryMinimum || salaryMaximum) {
            filterData.preferredSalary = [
                salaryMinimum || 0, //If no min value is set, default to 0
                salaryMaximum || 999999, //If no max value is set, default to 999999
            ];
        }

        handleSubmit(event);
    };

    return (
        <>
            <ToggleContent
                title="Pool creation"
                icon={<FormatListBulletedOutlinedIcon fontSize="small" />}
            >
                <Stack spacing={1} sx={{ mt: 2 }}>

                    <Box
                        sx={{
                            border: `2px solid ${theme.palette.grey[100]}`,
                            p: 1,
                            borderRadius: "10px",
                        }}
                    >
                        <Box sx={{ mb: 2 }}>
                            <LocationSearchOnline
                                formData={formData}
                                handleSubmit={handleInputSubmit}
                            />
                        </Box>
                        <Box>
                            <ExperienceFilters
                                handleSubmit={handleInputSubmit}
                                formData={formData}
                            />
                        </Box>

                        <Box sx={{ pt: "1.5rem", pl: ".5rem" }}>
                            <PreferredFilters
                                handleSubmit={handleInputSubmit}
                                formData={formData}
                            />
                        </Box>
                    </Box>
                </Stack>
            </ToggleContent>
        </>
    );
};

export default PoolCreationFilters;
